import React from "react"
import * as AppConstants from "../../../../utility/AppConstants"
//import InfoRiservatezza from '../../avvisi/InfoRiservatezza';

import TabRicaviCompensi from "../include/multiAnno/TabRicaviCompensi"
import TabValoreAggiunto from "../include/multiAnno/TabValoreAggiunto"
import TabReddito from "../include/multiAnno/TabReddito"
import TabIndicatori from "../include/multiAnno/TabIndicatori"
import TabGestioneCaratteristica from "../include/multiAnno/TabGestioneCaratteristica"
import TabRedditivita from "../include/multiAnno/TabRedditivita"
import TabGestioneExtra from "../include/multiAnno/TabGestioneExtra"
import TabIndicatoriSpecifici from "../include/multiAnno/TabIndicatoriSpecifici"
import TabAnomalie from "../include/multiAnno/TabAnomalie"
import TabTitle from "../include/TabTitle"

import HeaderTableTotali from "../../../table/multiAnno/HeaderTableTotali"
import BodyTable from "../../../table/multiAnno/BodyTable"
import {
    Collapsible,
    Table,
    SimpleCard,
    Messages
} from "@sogei/react-web-components-catalog"
import { ResponseDatiNazionaliMultiAnno } from "@/utility/model"
import InfoRiservatezza from "@/components/avvisi/InfoRiservatezza"

function TabTotali(props: any) {
    let datiNazionali: ResponseDatiNazionaliMultiAnno[] = props.datiNazionali
    let totale = props.totale
    let anni = datiNazionali.map((dati) => dati.anno)
    let codiciIsa = datiNazionali.map((d) => d.codIsa)

    return (
        <div id="tab-totali">
            <TabTitle title={AppConstants.TITLE_TOTALI} {...props} />

            <div className="row">
                <div className="col-12">
                    <SimpleCard
                        cardType="default"
                        title={""}
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <BodyTable
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                campo1={datiNazionali[0]}
                                                campo2={datiNazionali[1]}
                                                campo3={datiNazionali[2]}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI}{" "}
                                    </caption>
                                </Table>
                            </div>
                        }
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <h1 className="h3"> {AppConstants.DATI_AFFIDABILITA} </h1>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_RICAVI_COMPENSI}
                        titleHeading="h3"
                        body={
                            <>
                                <div className="table-responsive">
                                    <Table
                                        tableHead={
                                            <HeaderTableTotali
                                                codIsa={props.codIsa}
                                                macroarea={props.macroarea}
                                                anni={anni}
                                                codici={codiciIsa}
                                            />
                                        }
                                        tableBody={
                                            <>
                                                <TabRicaviCompensi
                                                    isCampo1={true}
                                                    isCampo2={true}
                                                    isCampo3={true}
                                                    campo1={datiNazionali[0]}
                                                    campo2={datiNazionali[1]}
                                                    campo3={datiNazionali[2]}
                                                />
                                            </>
                                        }
                                        tableOptions={["table-striped"]}
                                    >
                                        <caption className="sr-only">
                                            {AppConstants.TITLE_TOTALI} -{" "}
                                            {AppConstants.DATI_RICAVI_COMPENSI}
                                        </caption>
                                    </Table>
                                </div>
                                <div className="info_ricavi_compensi">
                                    {AppConstants.INFO_RICAVI_COMPENSI}
                                </div>
                            </>
                        }
                        id="ricavi-compensi-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_VALORE_AGGIUNTO}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabValoreAggiunto
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                campo1={datiNazionali[0]}
                                                campo2={datiNazionali[1]}
                                                campo3={datiNazionali[2]}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_VALORE_AGGIUNTO}
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="valore-aggiunto-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_REDDITO}
                        titleHeading="h3"
                        body={
                            <>
                                <div className="table-responsive">
                                    <Table
                                        tableHead={
                                            <HeaderTableTotali
                                                codIsa={props.codIsa}
                                                macroarea={props.macroarea}
                                                anni={anni}
                                                codici={codiciIsa}
                                            />
                                        }
                                        tableBody={
                                            <>
                                                <TabReddito
                                                    isCampo1={true}
                                                    isCampo2={true}
                                                    isCampo3={true}
                                                    campo1={datiNazionali[0]}
                                                    campo2={datiNazionali[1]}
                                                    campo3={datiNazionali[2]}
                                                />
                                            </>
                                        }
                                        tableOptions={["table-striped"]}
                                    >
                                        <caption className="sr-only">
                                            {AppConstants.TITLE_TOTALI} -{" "}
                                            {AppConstants.DATI_REDDITO}
                                        </caption>
                                    </Table>
                                </div>
                                <div className="info_ricavi_compensi">
                                    {AppConstants.INFO_REDDITO}
                                </div>
                            </>
                        }
                        id="reddito-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_INDICATORI_ELEM_AFF}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabIndicatori
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                campo1={datiNazionali[0]}
                                                campo2={datiNazionali[1]}
                                                campo3={datiNazionali[2]}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_INDICATORI_ELEM_AFF}
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="indicatori-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">&nbsp;</div>
            </div>

            <div className="row">
                <div className="col-12">
                    <h1 className="h3"> {AppConstants.DATI_ANOMALIA} </h1>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_GESTIONE_CAR}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabGestioneCaratteristica
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                campo1={datiNazionali[0]}
                                                campo2={datiNazionali[1]}
                                                campo3={datiNazionali[2]}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_ANOMALIA} -{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_GESTIONE_CAR
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="gestione-caratteristica-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_REDDITIVITA}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabRedditivita
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                campo1={datiNazionali[0]}
                                                campo2={datiNazionali[1]}
                                                campo3={datiNazionali[2]}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_ANOMALIA}-{" "}
                                        {AppConstants.DATI_ANOMALIA_REDDITIVITA}
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="gestione-redditivita-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_GESTIONE_EXTRA}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabGestioneExtra
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                campo1={datiNazionali[0]}
                                                campo2={datiNazionali[1]}
                                                campo3={datiNazionali[2]}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_ANOMALIA}-{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_GESTIONE_EXTRA
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="gestione-extra-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_INDICATORI_SPECIFICI}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabIndicatoriSpecifici
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                campo1={datiNazionali[0]}
                                                campo2={datiNazionali[1]}
                                                campo3={datiNazionali[2]}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_ANOMALIA} -{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_INDICATORI_SPECIFICI
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="indicatori-specifici-totali"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_ALTRI_INDICATORI}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTableTotali
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <TabAnomalie
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                campo1={datiNazionali[0]}
                                                campo2={datiNazionali[1]}
                                                campo3={datiNazionali[2]}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_TOTALI} -{" "}
                                        {AppConstants.DATI_ANOMALIA} -{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_ALTRI_INDICATORI
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="altri-indicatori-totali"
                    />
                </div>
            </div>

            <InfoRiservatezza />
        </div>
    )
}

export default TabTotali
